import React, { useEffect, useState } from "react";
import { Form } from "antd";
import { Input } from "antd";
import toast from "react-hot-toast";
import { ForgetOtpApi, SendemailApi } from "../../api/request/users";
import { useNavigate } from "react-router-dom";
import { setCookies } from "../../services/Cookies.jsx";
import { useSelector } from 'react-redux';
import LoadableButton from "../../components/buttons/LoadableButton.jsx";
import { handleApiError } from "../../utils/handleApiError.js";
import { useResponsive } from "../../hooks/useResponsive.js";
import Tagline from "./Tagline.jsx";

export default function PasswordOtp() {

  const { isMobile } = useResponsive();
  const navigate = useNavigate();
  const { broker } = useSelector(state => state.broker);
  const [isLoading, setIsLoading] = useState(false);
  const [timer, setTimer] = useState(120);
  const [FormData, setFormData] = useState({ otp: "" });

  const formatTime = (timer) => {
    const minutes = Math.floor(timer / 60);
    const remainingSeconds = timer % 60;

    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');

    return `${formattedMinutes}:${formattedSeconds}`;
  };

  useEffect(() => {
    setInterval(() => {
      setTimer(current => current !== 0 ? current - 1 : 0);
    }, 1000);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { otp } = FormData;
    if (!otp) {
      toast.error("OTP can not be empty.");
      return;
    }
    try {
      setIsLoading(true);
      let params = {
        Otp: FormData.otp,
        email: localStorage.getItem("email"),
        domain: 'upforex.live'
      }
      const { data } = await ForgetOtpApi(params);
      if (data?.success) {
        setCookies('passwordToken', data?.data?.token);
        toast.success(data?.message);
        navigate('/reset_password');
      }
      setIsLoading(false);
    } catch (error) {
      handleApiError(error);
      setIsLoading(false);
    }
  };

  const onChange = (e) => {
    const newValue = e.target ? e.target.value : e;
    setFormData({ ...FormData, otp: newValue });
  };

  const sharedProps = {
    onChange,
  };

  const resendOTPHandler = async () => {
    try {
      let params = { userEmail: localStorage.getItem('email'), domain: 'upforex.live' }
      const { data } = await SendemailApi(params);
      if (data?.success) {
        toast.success(data?.message);
        setTimer(120);
      }
    } catch (err) {
    }
  }

  return (
    <>
      {!isMobile ? (
        <div className='flex items-center justify-center min-h-screen bg-[#f9f9f9] auth-bg'>
          <Tagline />
          <div className='w-full max-w-md bg-white p-10 rounded-2xl shadow-xl'>
            <div className="flex justify-center mb-8">
              <img src='/assets/logo/logo.png' alt='logo' className='h-20 w-48 object-contain ' />
            </div>
            <div className="text-center">
              <p className="text-[#2F2B3D] text-2xl font-semibold auth-heading">OTP Verification</p>
              <p className="text-[silver] text-sm font-medium auth-com mt-2">
                Please enter the OTP and verify yourself
              </p>
            </div>
            <div className="w-full">
              <form autoComplete="off" onSubmit={handleSubmit}>
                <div className="w-full text-sm py-1">
                  <div className="relative">
                    <Form.Item
                      name="otp"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input.OTP
                        {...sharedProps}
                        value={FormData.otp}
                        style={{ width: '100%' }}
                      />
                    </Form.Item>
                  </div>
                </div>
                <div className="mt-6 text-center">
                  {
                    timer == 0 ? (<button onClick={resendOTPHandler} className="text-sm primary font-bold"><span className="text-black font-normal">Didn't receive it?</span> Resend OTP</button>) : (<span className="text-sm">Resend OTP in {formatTime(timer)}</span>)
                  }
                </div>
                <div className="mt-8">
                  <LoadableButton type='submit' className='bg-primary text-[#FFFFFF] font-semibold text-lg rounded-lg w-full py-2 text' lable='Verify' isLoading={isLoading} loadingLable='Verifying...' />
                </div>
              </form>

            </div>
          </div>
        </div>
      ) : (
        <div className="min-h-screen bg-blue-50 mobile-dashboard">
          <div className="p-5 pt-10">
            <div className="flex justify-center mb-8">
              <img
                src="/assets/logo/logo.png"
                alt="logo"
                className="h-16 w-44 object-contain"
              />
            </div>

            <div className="w-full">
              <div className="my-5 mt-10">
                <p className="text-xl font-bold mb-2 text-dark-200">
                  OTP Verification
                </p>
                <p className="text-gray-500">
                  Please enter the OTP and verify yourself
                </p>
              </div>

              <form autoComplete="off" onSubmit={handleSubmit}>
                <div className="w-full text-sm py-1">
                  <div className="relative">
                    <Form.Item
                      name="otp"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input.OTP
                        {...sharedProps}
                        value={FormData.otp}
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </div>
                </div>
                <div className="mt-5 text-center">
                  {timer === 0 ? (
                    <button
                      type="button"
                      onClick={resendOTPHandler}
                      className="text-sm primary font-bold"
                    >
                      <span className="text-black font-normal">
                        Didn't receive it?
                      </span>{" "}
                      Resend OTP
                    </button>
                  ) : (
                    <span className="text-sm">
                      Resend OTP in {formatTime(timer)}
                    </span>
                  )}
                </div>

                <div className="mt-5">
                  <LoadableButton
                    type="submit"
                    className="bg-primary text-[#FFFFFF] font-semibold text-lg rounded-[14px] w-full py-3 text"
                    lable="Verify"
                    isLoading={isLoading}
                    loadingLable="Verifying..."
                    disabled={FormData?.otp?.length !== 6}
                  />
                </div>

                <div className="primary flex items-center justify-center mt-5 text-sm">
                  <a href="/" className="underline">Back to login</a>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
